import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { BaseEndpoint } from '../../app.constants';
import { Http } from '@angular/http';
import { AdalService } from '../../shared/azure-authentication/adal.service';
import { SubregionAssignment } from './../loanofficerregionreference.model';

@Injectable()
export class SubregionService {

    @Output() requestAdded = new EventEmitter<any[]>();
    @Output() subregionAssignmentAdded = new EventEmitter<any>();
    @Output() subregionAssignmentUpdated = new EventEmitter<any>();
    @Output() subregionAssignmentDeleted = new EventEmitter<any>();

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl: string, private adalService: AdalService) { }

    async getSubregions() {
        const url = this.baseApiUrl + 'v1/subregion/readcollection/';
        let header = await this.adalService.createServiceHeader();
        return this.http.get(url, { headers: header }).toPromise().then(resp => {
            return resp.json().body;
        }).catch(this.handleError);
    }

    async getSubregionAssignments(id : string) {
        const url = this.baseApiUrl + 'v1/subregionassignment/getassignmentsbysubregion/' + id;
        let header = await this.adalService.createServiceHeader();
        return this.http.get(url, { headers: header }).toPromise().then(resp => {
            return resp.json().body;
        }).catch(this.handleError);
    }

    async updateSubregionAssignment(subregionAssignment: SubregionAssignment): Promise<SubregionAssignment> {
        const url = this.baseApiUrl + 'v1/subregionassignment/update/';
        return this.http
            .post(url, JSON.stringify(subregionAssignment), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var success = resp.status as number;
                if (success == 200) {
                    this.subregionAssignmentUpdated.emit(subregionAssignment);
                }
                return success;
            })
            .catch(resp => {
                var errors = resp.json().messages;
                if (errors)
                    return this.handleError(errors.map(({ description }) => description));
                else
                    return this.handleError(null);
            });
    }

    async deleteSubregionAssignments(subregionAssignmentId: string): Promise<boolean> {
        var url = this.baseApiUrl + 'v1/subregionassignment/delete/' + subregionAssignmentId;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var success = !resp.json().hasErrors as boolean;
                if (success) {
                    this.subregionAssignmentDeleted.emit(subregionAssignmentId);
                }
                return success;
            })
            .catch(this.handleError);
    }

    async addSubregionAssignments(subregionAssignment) {
        const url = this.baseApiUrl + 'v1/subregionassignment/create';
        let header = await this.adalService.createServiceHeader();
        return this.http.post(url, JSON.stringify(subregionAssignment), { headers: header }).toPromise().then(resp => {
            const newSkillset = resp.json().body as SubregionAssignment;
            this.subregionAssignmentAdded.emit(newSkillset);
            return newSkillset;
        }).catch(this.handleError);
    }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-officer-region-reference/subregions/subregions.service.ts